<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->

    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Update Learner Canteen Fees</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row fluid justify="center">
          <v-radio-group v-model="radios" row>
            <v-radio label="Update Student Fees" @change="learner_transport_fees_installment_details_new = []"
              value="update_fees"></v-radio>
            <v-radio label="Change Menu Type" @change="learner_transport_fees_installment_details = []"
              value="update_menu"></v-radio>
          </v-radio-group>
        </v-row>
      </v-card>

      <v-card class="box" v-if="radios=='update_fees'">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Update Learner Canteen Fees</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="2">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year"
              @change="getInstallmentData()" />
          </v-col>
          <v-col cols="12" sm="3" v-if="all_learner_list!=''">
            <p><b>Learner</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="learner" :items="all_learner_list"
              item-text="learner" item-value="id" label="Student" outlined persistent-hint
              hint="Please Select Student" />
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="2" md="2"></v-col>
          <v-col col="12" sm="4" md="4">
            <v-btn color="warning" @click="fetch()">Fetch</v-btn>
          </v-col>
        </v-row>
        <v-card v-if="learner_canteen_fees_installment_details!=''" class="box">
          <v-data-table :headers="headers" :items="learner_canteen_fees_installment_details" :search="search">
            <template v-slot:top>
              <v-toolbar flat class="toolbar">
                <v-toolbar-title>Installment List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                  hide-details></v-text-field>
              </v-toolbar>
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              <v-row dense>
                <!-- <v-col cols="12" md="6" sm="6"> -->
                <v-text-field type="number" class="pt-3" persistent-hint hint="Please Enter Fee" label="Enter Fee"
                  outlined rounded dense v-model="item.amount"></v-text-field>
                <!-- </v-col>
                            <v-col cols="12" md="4" sm="4"> -->
                <v-btn rounded class="button mt-6" small :loading="loader" @click="editFee(item)">Save</v-btn>
                <!-- </v-col> -->
              </v-row>
            </template>
          </v-data-table>
        </v-card>
      </v-card>

      <v-card class="box" v-if="radios=='update_menu'">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Update Canteen Menu Type</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br>
        <v-row justify="center" dense>
          <v-col cols="12" sm="2">
            <!-- <p><v-icon color="error">*</v-icon><b>Academic Year</b></p> -->
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year"
              @change="getInstallmentData()" />
          </v-col>
          <v-col cols="12" sm="3" v-if="all_learner_list!=''">
            <!-- <p><b>Learner</b></p> -->
            <v-autocomplete color="#0F2027" dense rounded required v-model="learner" :items="all_learner_list"
              item-text="learner" item-value="id" label="Student" outlined persistent-hint
              hint="Please Select Student" />
          </v-col>
          <v-col col="12" sm="2" md="2">
            <v-btn color="warning" @click="fetch()">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="box" v-if="learner_canteen_fees_installment_details!=''">
        <v-data-table :headers="headers_2" dense class="elevation-1" :items="learner_canteen_fees_installment_details">
          <template v-slot:top>
            <v-toolbar flat dense class="toolbar">
              <v-toolbar-title>Student Canteen-Installment Details</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.update_menu`]="{ item }">
            <v-row justify="center" dense>
              <v-col col="12" sm="4" md="4">
                <v-autocomplete dense rounded required v-model="item.canteenmenutype_id" :items="canteen_menutype_list"
                  item-text="name" item-value="id" label="Select Menu" outlined persistent-hint
                  hint="Please Select Menu" />
              </v-col>
              <v-col col="12" sm="2" md="2">
                <v-btn color="warning" @click="updateMenuType(item)">Update</v-btn>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    radios:null,
    search: "",
    loader: false,
    snackbar_msg: "",
    color: "",
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    snackbar: false,
    overlay: false,
    ay_list: [],
    ay: "",
    all_learner_list: [],
    learner: "",
    headers: [
      { text: "SR No", value: "srno" },
      { text: "Student", value: "name" },
      { text: "Installment", value: "canteeninstallment" },
       { text: "Amount To Pay", value: "amount" },
      { text: "Paid Till Now", value: "paid_till_now" },
    ],
     headers_2: [
        { text: "Sr No", value: "srno" },
        { text: "Installment", value: "canteeninstallment" },
        { text: "Amount", value: "amount" },
        { text: "Amount Paid", value: "paid_till_now" },
        { text: "Menu Selected", value: "canteenmenutype" },
        { text: "From Date", value: "from_date" },
        { text: "To Date", value: "to_date" },
        { text: "Change Manu", value: "update_menu" },
      ],
    learner_canteen_fees_installment_details:[],canteen_menutype_list:[]
  }),
  methods: {
      updateMenuType(item){
         if(!confirm("Are You Sure You Want To Update Menu For This Instellment.."));
            this.loader=true
              const data = {
                  canteen_fees_data: item,
              };
              axios
                  .post("/Canteen/editLearnerCanteenFeesInstellmentMenuType", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Updated successfully");
                          this.fetch();
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong!!!");
                  })
                  .finally(() => {
                     this.loader=false
                  });
      },

     editFee(item) {
            this.loader=true
              const data = {
                  canteen_fees_data: item,
              };
              axios
                  .post("/Canteen/editLearnerCanteenFeesInstellmentAmount", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.showSnackbar("#4caf50", "Updated successfully");
                          this.fetch();
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong!!!");
                  })
                  .finally(() => {
                     this.loader=false
                  });
          },
    fetch() {
     
      if(this.learner==''){
          this.showSnackbar("red","Please Select Students");
          return
      }
      const data = {
        academicYear: this.ay,
        learner: this.learner,
      };
      this.overlay = true;
      axios
        .post("/Canteen/fetchCanteenApplicationDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            //this.showSnackbar("green", res.data.snackbar);
            this.learner_canteen_fees_installment_details =res.data.learner_canteen_fees_installment_details;
            this.canteen_menutype_list =res.data.canteen_menutype_list;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          // this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    onLoad() {
      axios
        .post("Canteen/approveTCanteenApplication")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
            this.all_learner_list = res.data.learner_list;
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>